/** Parse display or API date strings to epoch ms for table sorting. */
export function parseRecordDateTime(dateStr) {
  if (dateStr == null || dateStr === '' || dateStr === '-') return 0;
  const raw = String(dateStr).trim();
  const direct = new Date(raw);
  if (!Number.isNaN(direct.getTime())) return direct.getTime();
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return new Date(parseInt(iso[1], 10), parseInt(iso[2], 10) - 1, parseInt(iso[3], 10)).getTime();
  }
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const parts = raw.split(' ');
  if (parts.length === 3) {
    const month = months.indexOf(parts[0]);
    const day = parseInt(parts[1].replace(',', ''), 10);
    const year = parseInt(parts[2], 10);
    if (month >= 0 && Number.isFinite(day) && Number.isFinite(year)) {
      return new Date(year, month, day).getTime();
    }
  }
  return 0;
}

export function getRecordSortId(record) {
  return record.stockId ?? record.stockOutId ?? record.transportId ?? record.advanceId ?? record.id;
}

export function getRecordSortDate(record) {
  return (
    record.rawDate ||
    record.dateOfTranscationRaw ||
    record.date ||
    record.dateOfTranscation ||
    record.startDate ||
    record.endDate ||
    ''
  );
}

/** Newest record first — used after API load and when primary sort values tie. */
export function compareRecordsNewestFirst(a, b) {
  const dateDiff = parseRecordDateTime(getRecordSortDate(b)) - parseRecordDateTime(getRecordSortDate(a));
  if (dateDiff !== 0) return dateDiff;
  const aId = Number(getRecordSortId(a));
  const bId = Number(getRecordSortId(b));
  if (Number.isFinite(aId) && Number.isFinite(bId) && aId !== bId) {
    return bId - aId;
  }
  const aStr = String(getRecordSortId(a) ?? '');
  const bStr = String(getRecordSortId(b) ?? '');
  if (aStr !== bStr) return bStr.localeCompare(aStr);
  return (b.apiIndex ?? 0) - (a.apiIndex ?? 0);
}

export function defaultSortDirectionForColumn(column) {
  return ['date', 'dateOfTranscation', 'startDate', 'endDate'].includes(column) ? 'desc' : 'asc';
}
